import React, { createContext, useContext, useEffect, useState } from "react";

interface IncomeType {
  value: number;
  name: string;
  userId: string;
}

interface IncomesContextType {
  incomes: IncomeType[];
  totalIncome: number;
  addIncome: ({ value, name }: IncomeType) => void;
  addArrayIncomes: (expensesArray: IncomeType[]) => void;
  removeIncome: (text: string) => void;
}

interface Props {
  children: React.ReactNode;
}

export const IncomesContext = createContext<IncomesContextType>(
  {} as IncomesContextType
);

export const IncomesProvider = ({ children }: Props) => {
  const [incomes, setIncomes] = useState<IncomeType[] | []>([]);
  const [totalIncome, setTotalIncome] = useState<number>(0);

  useEffect(() => {
    let total = 0;

    for (let i = 0; i < incomes.length; i++) {
      total += Number(incomes[i].value);
    }

    setTotalIncome(total);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [incomes]);

  const addIncome = ({ value, name, userId }: IncomeType) => {
    setIncomes([...incomes, { value, name, userId }]);
  };

  const addArrayIncomes = (incomesArray: IncomeType[]) => {
    const uniqueIncomes = incomesArray.filter(
      (newIncome) =>
        !incomes.some(
          (existingIncome) =>
            existingIncome.name === newIncome.name &&
            existingIncome.userId === newIncome.userId
        )
    );
    setIncomes([...incomes, ...uniqueIncomes]);
  };

  const removeIncome = (text: string) => {
    const filteredArray = incomes.filter((income) => income.name !== text);

    setIncomes(filteredArray);
  };

  return (
    <IncomesContext.Provider
      value={{
        incomes,
        addIncome,
        removeIncome,
        addArrayIncomes,
        totalIncome,
      }}
    >
      {children}
    </IncomesContext.Provider>
  );
};

export const useIncomes = () => {
  const context = useContext(IncomesContext);
  if (!context) {
    throw new Error("useExpenses must be used within an ExpensesProvider");
  }
  return context;
};
